import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { useInView } from '../hooks/useInView';
export function Guarantee() {
  const {
    ref,
    isVisible
  } = useInView();
  return <section className="py-24 px-4" data-id="element-93">
      <div className="max-w-3xl mx-auto" data-id="element-94">
        <div ref={ref} className={`bg-gradient-to-br from-[#1A1A1A] to-[#0A0A0A] border border-gray-800 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden ${isVisible ? 'anim-fade-scale' : 'anim-hidden'}`} data-id="element-95">
          <ShieldCheck className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] text-white/[0.02] pointer-events-none" data-id="element-96" />

          <div className="relative z-10" data-id="element-97">
            <div className="w-20 h-20 bg-gold-500/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-98">
              <ShieldCheck className="w-10 h-10 text-gold-500" data-id="element-99" />
            </div>
            <h2 className="font-serif text-3xl md:text-4xl font-bold text-white mb-8" data-id="element-100">
              Garantía Total de 30 Días
            </h2>
            <p className="text-xl text-gray-300 mb-6 font-medium" data-id="element-101">
              Si aplicás el Sistema de Presupuesto Inverso durante 30 días y no
              notás ningún cambio en cómo se mueve tu dinero, te devolvemos el
              100% de lo que pagaste.
            </p>
            <p className="text-gray-400 mb-8" data-id="element-102">
              Sin preguntas. Sin formularios complicados. Sin explicaciones.
            </p>
            <div className="h-px w-full max-w-md mx-auto bg-gradient-to-r from-transparent via-gray-700 to-transparent mb-8" data-id="element-103" />
            <p className="text-gray-300 mb-4" data-id="element-104">
              La razón por la que podemos garantizar esto es simple:{' '}
              <strong className="text-white" data-id="element-105">
                el sistema funciona porque trabaja a favor de cómo funciona tu
                cerebro, no en contra.
              </strong>
            </p>
            <p className="text-gold-400 font-semibold text-lg" data-id="element-106">
              No estamos apostando a tu fuerza de voluntad. Estamos apostando al
              diseño.
            </p>
          </div>
        </div>
      </div>
    </section>;
}